import type React from "react";
import type { ButtonProps } from "./Button.model";
import { StyledButton } from "./Button.styled";

export const Button: React.FC<ButtonProps> = ({
  children,
  onClick,
  dataCy,
  disabled,
  itemId,
  module,
  variant,
  width,
  height,
}) => (
  <StyledButton
    data-cy={dataCy}
    data-mdat="element-clicked"
    data-mdat-item-id={itemId}
    data-mdat-module={module}
    disabled={disabled}
    height={height}
    variant={variant}
    width={width}
    onClick={(event) => {
      if (!disabled && onClick) return onClick(event);
      return false;
    }}
  >
    {children}
  </StyledButton>
);

export default Button;
